const envelopeIcon =
  "https://snapshelf.s3.us-west-1.amazonaws.com/assets/landing-page/contact/envelope.png";
const userIcon =
  "https://snapshelf.s3.us-west-1.amazonaws.com/assets/landing-page/contact/user.png";

export const contactIcons = {
  envelopeIcon,
  userIcon,
};
